import {
    areaStyle,
    customStyle,
    getNode,
    getScore,
    pointStyle,
    strokeStyle,
    scaledScore,
    onlyUniqueByKey
} from "./overlaysUtils";

export const risksList = [
    {
        label: 'Aléas naturels',
        items: [
            {
                id: 'argiles',
                label: 'Retrait Gonflements des sols Argileux',
                altLabel: 'Sols Argileux',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'argiles']),
                score: (summaryRisk) => scaledScore(getScore(summaryRisk, ['data'])),
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Niveau d'exposition : ${properties.label}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'rga'])
            },
            {
                id: 'secheresses',
                label: 'Sécheresse géotechnique',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'secheresses', 'scores','actuel']),
                score: (summaryRisk) => getScore(summaryRisk, ['data']),
                tilesId: 'score_secheresse_actuel',
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Niveau d'exposition : ${properties.label}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'secheresses'])
            },
            {
                id: 'cavites',
                label: 'Cavités',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'cavites']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0,
                style: (properties, valuesRef) => {
                    const value = valuesRef.find(v => v.label.toLowerCase() === properties.typecavite);
                    if(value){
                        return value.shape === 'circle'? pointStyle(value.color) : customStyle(`${value.shape}${value.color.substring(1)}`)
                    }
                    return pointStyle('#000', '#fff')
                },
                popupContent: (properties) => `Type de cavité : ${properties.typecavite}<br>Nature de cavité : ${properties.naturecavite}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'cavites'])
            },
            {
                id: 'inondations',
                label: 'Inondation',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'inondations','scores','actuel']),
                score: (summaryRisk) => getScore(summaryRisk, ['data']),
                tilesId: 'score_inondation_actuel',
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Niveau d'exposition : ${properties.label}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'inondations'])
            },
            {
                id: 'tri',
                label: "Territoires à Risques d'Inondation",
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'inondations', 'tri']),
                tilesId: 'tris',
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => undefined,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'tri'])
            },
            {
                id: 'mouvements_terrain',
                label: 'Mouvements de terrain',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'mouvements_terrain']),
                count: (summaryRisk) => getScore(summaryRisk, ['data', 'total']) || 0,
                style: (properties, valuesRef) => {
                    const value = valuesRef.find(v => v.label === properties.libelletype);
                    return value ? customStyle(`${value.shape}${value.color.substring(1)}`) : pointStyle('#ffff00')
                },
                popupContent: (properties) => properties.libelletype,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'mouvements-terrain'])
            },
            {
                id: 'radon',
                label: 'Radon',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'radon']),
                score: (summaryRisk) => scaledScore(getNode(summaryRisk, ['data', 'potentielRadon'])),
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Niveau d'exposition : ${properties.label}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'radon'])
            },
            {
                id: 'seismes',
                label: 'Séisme',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'seismes']),
                score: (summaryRisk) => getScore(summaryRisk, ['data']),
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Zone de sismicité : ${properties.zone_sismicite}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'seisme'])
            },
            {
                id: 'submersions',
                label: 'Submersion',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'submersions','scores','actuel']),
                score: (summaryRisk) => getScore(summaryRisk, ['data']),
                tilesId: 'score_submersion_actuel',
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Niveau d'exposition : ${properties.label}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'submersion'])
            },
            {
                id: 'submersions_projection',
                label: 'Submersion - 2100',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'submersions','scores','futur']),
                score: (summaryRisk) => getScore(summaryRisk, ['data']),
                tilesId: 'score_submersion_futur',
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Niveau d'exposition : ${properties.label}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'submersion-2100'])
            },
            {
                id: 'tempetes',
                label: 'Tempête',
                summaryRiskNode: (summary) => getNode(summary, ['naturels',  'tempetes', 'scores', 'actuel']),
                score: (summaryRisk) => getScore(summaryRisk, ['data']),
                tilesId: 'score_tempete',
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Niveau d'exposition : ${properties.label}`,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'tempete'])
            },
            {
                id: 'traits_cote',
                label: 'Trait de côte',
                altLabel: 'Évolution du trait de côte',
                summaryRiskNode: (summary) => getNode(summary, ['naturels', 'traits_cote']),
                isPresent: (summaryRisk) => getNode(summaryRisk, ['data']) || false,
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => properties.label,
                isActive: (features) => getNode(features, ['risques', 'naturels', 'traits-cote'])
            }
        ]
    },
    {
        label: 'Aléas technologiques',
        items: [
            {
                id: 'icpe',
                label: "Installations Classées pour la Protection de l'Environnement",
                altLabel: 'Installations Classées (ICPE)',
                summaryRiskNode: (summary) => getNode(summary, ['technologiques', 'icpe']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0,
                style: (properties, valuesRef) => {
                    const value = valuesRef.find(v => v.label === properties.lib_seveso);
                    return pointStyle(value ? value.color : '#000ff');
                },
                popupContent: (properties) => `${properties.famille_ic} - ${properties.lib_seveso}`,
                isActive: (features) => getNode(features, ['risques', 'technologiques', 'icpe'])
            },
            {
                id: 'sites_sols_pollues',
                label: 'Sites et sols pollués',
                summaryRiskNode: (summary) => getNode(summary, ['technologiques', 'sites_sols_pollues']),
                count: (summaryRisk) => getNode(summaryRisk, ['data']) || 0,
                style: (properties, valuesRef) => {
                    const value = valuesRef.find(v => v.label.includes(properties.status.toLowerCase()))
                    return  pointStyle(value ? value.color : '#000')
                },
                popupContent: (properties) => `Statut : ${properties.status}`,
                isActive: (features) => getNode(features, ['risques', 'technologiques', 'sites-sols-pollues'])
            },
            {
                id: 'nucleaires',
                label: 'Installations nucléaires',
                summaryRiskNode: (summary) => getNode(summary, ['technologiques', 'nucleaires']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0 ,
                style: (properties, valuesRef) => {
                    const value = valuesRef.find(v => properties && v.label === (properties.typeLeg || properties.type_leg));
                    return value ? customStyle(value.shape) : pointStyle('#ff0000')
                },
                popupContent: (properties) => properties.typeLeg || properties.type_leg,
                isActive: (features) => getNode(features, ['risques', 'technologiques', 'nucleaires'])
            } 
        ]
    },
    {
       label: 'Zonages réglementaires',
       items: [
        {
            id: 'pprn',
            label: 'Plan de Prévention des Risques Naturels',
            summaryRiskNode: (summary) => getNode(summary, ['naturels', 'pprn']),
            count: (summaryRisk) => getNode(summaryRisk, ['data']) ? getNode(summaryRisk, ['data']).length : 0,
            style: (properties) => areaStyle(properties.color),
            popupContent: (properties) => properties.label,
            isActive: (features) => getNode(features, ['risques', 'zonage-reglementaire', 'pprn'])
        },
        {
            id: 'pprt',
            label: 'Plan de Prévention des Risques Technologiques',
            summaryRiskNode: (summary) => getNode(summary, ['technologiques', 'pprt']),
            count: (summaryRisk) => getScore(summaryRisk, ['data']) ?  getScore(summaryRisk, ['data']).length : 0,
            style: (properties) => areaStyle(properties.color),
            popupContent: (properties) => properties.label,
            isActive: (features) => getNode(features, ['risques', 'zonage-reglementaire','pprt'])
        }
       ] 
    }
]

export const urbanismeList = [
    {
        label: 'Nuisances',
        items: [
            {
                id: 'lignes_electriques',
                label: 'Lignes électriques',
                summaryRiskNode: (summary) => getNode(summary, ['lignes_electriques']),
                style: (properties, valuesRef) => {
                    const value = valuesRef.find(v => v.label === properties.tension);
                    return strokeStyle(value ? value.color : '#000', 0)
                },
                popupContent: (properties) => `Tension : ${properties.tension}`,
                isActive: (features) => getNode(features, ['urbanisme', 'nuisances', 'lignes-electriques'])
            },
            {
                id: 'peb',
                label: "Plan d'Exposition au Bruit",
                summaryRiskNode: (summary) => getNode(summary, ['peb']),
                style: (properties) => areaStyle(properties.color),
                popupContent: (properties) => `Zone ${properties.zone} : Lden compris entre ${properties.indldenext} et ${properties.indldenint}`,
                isActive: (features) => getNode(features, ['urbanisme', 'nuisances', 'peb'])
            },
            {
                id: 'voies_ferrees',
                label: 'Voies ferrées',
                summaryRiskNode: (summary) => getNode(summary, ['voies_ferrees']),
                style: (properties, valuesRef) => {
                    const value = valuesRef.find(v => v.label === properties.nature)
                    return {
                        color: value ? value.color : '#000',
                        weight: properties.nature === 'LGV' ? 4 : 2,
                        dashArray: ['Funiculaire ou crémaillère', 'Voie de service'].includes(properties.nature) ? '2, 6' : undefined
                    }
                },
                popupContent: (properties) => `${properties.nature}`,
                isActive: (features) => getNode(features, ['urbanisme', 'nuisances', 'voies-ferrees'])
        
            }
        ]
    },
    {
        label: 'Mobilité',
        items: [
            {
                id: 'amenagements_cyclables',
                label: 'Aménagements cyclables',
                hasMissingData: false,
                summaryRiskNode: (summary) => getNode(summary, ['amenagements_cyclables']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0,
                attributions: 'Geovelo',
                style: (properties, valuesRef) => strokeStyle(valuesRef[0].color, false),
                popupContent: (properties) => {
                    const label_d = properties.amenagement_droit ? `Aménagement droit : ${properties.amenagement_droit.toLowerCase()}` : undefined
                    const label_g = properties.amenagement_gauche ? `Aménagement gauche : ${properties.amenagement_gauche.toLowerCase()}` : undefined
                    return [label_d, label_g].filter(elem => elem !== undefined).join("<br>")
                },
                isActive: (features) => getNode(features, ['urbanisme', 'mobilite', 'amenagements-cyclables']),
                disable: (summaryRisk) => (getNode(summaryRisk, ['data', 'total']) || 0) === 0,
            }
        ]
    },
    {
        label: 'Patrimoine',
        items: [
            {
                id: 'monuments_historiques',
                label: 'Monuments historiques',
                summaryRiskNode: (summary) => getNode(summary, ['monuments_historiques']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0,
                style: (properties, valuesRef) => customStyle(`${valuesRef[0].shape}${valuesRef[0].color.substring(1)}`),
                popupContent: (properties) => properties.tico,
                isActive: (features) => getNode(features, ['urbanisme', 'patrimoine', 'monuments-historiques'])
            }
        ]
    }
]

export const mobiliteList = [
    {
        label: 'Mobilité',
        items: [
            {
                id: 'amenagements_cyclables',
                label: 'Aménagements cyclables',
                hasMissingData: false,
                summaryRiskNode: (summary) => getNode(summary, ['amenagements_cyclables']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0,
                attributions: 'Geovelo',
                style: (properties, valuesRef) => strokeStyle(valuesRef[0].color, false),
                popupContent: (properties) => {
                    const label_d = properties.amenagement_droit ? `Aménagement droit : ${properties.amenagement_droit.toLowerCase()}` : undefined
                    const label_g = properties.amenagement_gauche ? `Aménagement gauche : ${properties.amenagement_gauche.toLowerCase()}` : undefined
                    return [label_d, label_g].filter(elem => elem !== undefined).join("<br>")
                },
                disable: (summaryRisk) => (getNode(summaryRisk, ['data', 'total']) || 0) === 0,
            },
            {
                id: 'borne_recharge',
                label: 'Bornes de recharge',
                hasMissingData: false,
                summaryRiskNode: (summary) => getNode(summary, ['borne_recharge']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0,
                attributions: 'Ministère de la Transition écologique',
                style: (properties, valuesRef) => {
                    // Group by power range
                    let power_range = 100.0;
                    let power_threshold = Math.trunc(properties.puissance_nominale / power_range) * power_range;
                    let hue = 120 - (power_threshold * (120/400.0));
                    return {
                        ...pointStyle('#000', `hsl(${hue}, 100%, 50%)`),
                        radius: Math.log(power_threshold+power_range) * 2
                    };
                },
                popupContent: (properties) => {
                    return `${properties.nom_station} ${(properties.puissance_nominale ? Math.trunc(properties.puissance_nominale) + ' kW' : '')}`
                },
                legend: (values) => {
                    return values.filter(onlyUniqueByKey("puissance")).map(v => {
                        // Group by power range
                        let power_range = 100.0;
                        let power_threshold = Math.trunc(v.puissance / power_range) * power_range;
                        let hue = 120 - (power_threshold * (120/400.0));
                        return {
                            ...v,
                            label: `${power_threshold}-${power_threshold+power_range} kW`,
                            color: '#000',
                            strokeWidth: 5,
                            fillColor: `hsl(${hue}, 100%, 50%)`,
                            shape: 'circle'
                        };
                    }).filter((v, idx, arr) => arr.findIndex(item => item.label === v.label) === idx);
                },
                disable: (summaryRisk) => (getNode(summaryRisk, ['data', 'total']) || 0) === 0,
            },
            {
                id: 'parking_velo',
                label: 'Parkings vélos',
                hasMissingData: false,
                summaryRiskNode: (summary) => getNode(summary, ['parking_velo']),
                count: (summaryRisk) => getNode(summaryRisk, ['data', 'total']) || 0,
                attributions: 'Ministère de la Transition écologique',
                style: (properties, valuesRef) => {
                    let color = properties.gratuit ? '#0f0' : '#f00';
                    return pointStyle(color, '#ccc');
                },
                popupContent: (properties) => {
                    let label = properties.gratuit ? 'Gratuit' : 'Payant';
                    return `${properties.capacite} places (${(label)})`
                },
                legend: (values) => {
                    return values.filter(onlyUniqueByKey("gratuit")).map(v => {
                        let label = v.gratuit ? 'Gratuit' : 'Payant';
                        let color = v.gratuit ? '#0f0' : '#f00';
                        return {
                            ...v,
                            label: label,
                            color: color,
                            strokeWidth: 5,
                            fillColor: '#ccc',
                            shape: 'circle'
                        };
                    });
                },
                disable: (summaryRisk) => (getNode(summaryRisk, ['data', 'total']) || 0) === 0,
            }
        ]
    }
]
